import React from 'react';
import axios from 'axios';
import { Grid, Button } from "@material-ui/core/";
// const FormItem = Form.Item;
import TextField from "@material-ui/core/TextField";
// import Link from '@material-ui/core/Link';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import AttachMoneyRoundedIcon from '@material-ui/icons/AttachMoneyRounded';
class StatusCard extends React.Component<any, any>{
  constructor(props) {
    super(props)
    this.state = {
      values: [{ index: Math.random(), question: '', answer: '' }],
      question: '',
      answer: '',
      editId: null,
      edit: false,
    }
    // this.state = { values: [{question: '',response: ''}] };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }


  componentDidUpdate() {
    setTimeout(() => this.setState({ errorMessage: '' }), 40000);
    setTimeout(() => this.setState({ sucessMessage: '' }), 40000);
  }
  uploadDocument = (e) => {
    console.log(e);
  }



  handlequestionChange = event => { this.setState({ question: event.target.value }) }
  handleanswerNameChange = event => {
    this.setState({ answer: event })
  }

  handleSubmit = event => {
    event.preventDefault();
    event.target.reset()
    console.log(this.props.rowId);
    let rId = this.props.rowId;
    const posts = rId;
    console.log(posts);
    // Based on several assumptions: single obj returned, posts is never empty
    axios.post('https://gatewayapi.invest19.com/api/faqs',
      {
        ipoId: this.props.rowId,
        faqList: [
          {
            question: this.state.question,
            answer: this.state.answer,
          }
        ]
      }
    ).then(res => {
      this.getData();
      this.setState({ question: '' })
      this.setState({ answer: '' })
    })
      .catch(err => {
        this.setState({ errorMessage: err.message });
      })
  }

  handleUpdate = event => {
    event.preventDefault();
    event.target.reset()
    console.log(this.props.rowId);
    let rId = this.props.rowId;
    const posts = rId;
    console.log(posts);
    // Based on several assumptions: single obj returned, posts is never empty
    axios.post('https://gatewayapi.invest19.com/api/faqs/',
      {
        ipoId: this.props.rowId,
        faqList: [
          {
            id: this.state.editId,
            question: this.state.question,
            answer: this.state.answer,
          }
        ]
      }
    ).then(res => {
      this.getData();
      this.setState({ question: '' })
      this.setState({ answer: '' })
      this.setState({ edit: false })
    })
    // this.setState({ posts });

    // .catch(err => {
    //   this.setState({ errorMessage: err.message });
    // })
  }

  componentDidMount() {
    this.getData()
  };

  getData() {
    let rId = this.props.rowId;
    axios.get(`https://gatewayapi.invest19.com/performance/get/all/orders/total/details?page_from=0&page_to=1000&date_from=&date_to=`)
      .then(res => {
        const faq = res.data;
        this.setState({ faq });
      })
  };

  delete(id) {
    fetch(`https://gatewayapi-uat.invest19.com/api/faqs/` + id,
      {
        method: 'DELETE',
      }).then(res => {
        this.getData();
      })

  }
  edit(faq) {
    this.setState({ question: faq.question });
    this.setState({ answer: faq.answer });
    this.setState({ edit: true });
    this.setState({ editId: faq.id })

  }

  // createUI() {
  //   return this.state.values.map((el, i) =>

  //   )
  // }


  handleChange(i, event) {
    let values = [...this.state.values];
    values[i][event.target.id] = event.target.value;
    this.setState({ values });
  }

  addClick() {
    this.setState(prevState => ({ values: [...prevState.values, { question: '', response: '', }] }))
  }

  removeClick(i) {
    let values = [...this.state.values];
    values.splice(i, 1);
    this.setState({ values });
  }




  // componentDidMount() {
  //   console.log(this.props.rowId);
  //   let rId = this.props.rowId;
  //   axios.get(`https://gatewayapi.invest19.com/api/faqs/${rId}`)
  //     .then(res => {
  //       const posts = res.data;
  //       this.setState({ posts });
  //     })
  // }


  //   async componentDidMount() {  
  //     let rIdD = this.props.rowId;   
  //     const { data } = await axios.get('https://gatewayapi.invest19.com/api/faqs/${rIdD}')
  //     this.setState({posts: data, isLoading: false})
  //     console.log(this.state.posts)
  // }



  render() {
    return (

      <Grid container className="CoomonT">
        {this.state.faq &&
          <Grid className="faqListC">
            {this.state.faq.map(faqList => (

<Grid container className="status">
    <Grid item xs={4} className="card"> 
    <div className="inner_P">
      <div className="Fn"><PersonOutlineIcon/></div>
      <div>
        <h4>Total No Users</h4>
        <span>{faqList.TotalUser}</span>
      </div>
    </div>
    </Grid>
    <Grid item xs={4} className="card"> 
    <div className="inner_P">
      <div className="Fn"><ShoppingCartOutlinedIcon/></div>
      <div>
        <h4>Total No Trade</h4>
        <span>{faqList.TotalTrade}</span>
      </div>
    </div>
    </Grid>
    <Grid item xs={4} className="card"> 
    <div className="inner_P">
      <div className="Fn"><AttachMoneyRoundedIcon/></div>
      <div>
        
        <h4>Total Net Volume</h4>
        <span>{faqList.TotalVolume}</span>
      </div>
    </div>
    </Grid>
</Grid>

            ))}

          </Grid>}



      </Grid>






    )
  }
}
export default StatusCard;
